import React, { useState } from "react";
import { useSnackbar } from "notistack";

import {
  Button,
  Dialog,
  Grid,
  IconButton,
  makeStyles,
  Typography,
  withStyles,
  InputBase,
  Fab,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

import LoadingButton from "../Components/LoadingButton";

import { refreshPoolLP } from "../apiFunctions";
import { exitStack, withdrawStack } from "./StackingFunctions";

const styles = (theme) => ({
  dialogContainer: {
    borderRadius: theme.spacing(2),
  },
  titleSection: {
    padding: theme.spacing(2),
  },
  titleText: {
    alignSelf: "center",
  },
  hr: {
    margin: 0,
    color: theme.palette.grey[400],
  },
  container: {
    padding: theme.spacing(1),
    minHeight: "80px",
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(2),
    borderColor: theme.palette.grey[300],
    borderWidth: "1px",
    borderStyle: "solid",
    marginBottom: theme.spacing(2),
  },
  fab_max: {
    minWidth: "initial",
    height: "initial",
    fontSize: "10px",
    padding: "0px 4px",
    marginLeft: theme.spacing(0.5),
    boxShadow: "none",
    borderRadius: theme.spacing(1),
  },
  input: {
    ...theme.typography.h5,
    width: "100%",
  },
  infoLoadingBTNBox: {
    margin: "0px -8px",
  },
  buttons: {
    borderRadius: "14px",
    width: "100%",
  },
});

const useStyles = makeStyles(styles);

// This is a modified version of MaterialUI's DialogTitle component, I've added a close button in the top right corner
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.titleSection}
      {...other}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignContent="center"
      >
        <Typography variant="body1" className={classes.titleText}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </Grid>
    </MuiDialogTitle>
  );
});

function UnStackDialog({
  onClose,
  open,
  tokenAddress,
  stakedBefore,
  poolIndex,
  signer,
  stacking,
  chainID,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");

  // Determines whether the button should be enabled or not
  const isBtnEnabled = () => {
    const parsedInput = parseFloat(amount);
    return (
      !isNaN(parsedInput) && 0 < parsedInput && parsedInput <= stakedBefore
    );
  };

  const exit = () => {
    console.log("Attempting to token exit...");
    setLoading(true);

    exitStack(stacking, poolIndex, signer)
      .then(() => {
        setLoading(false);
        setAmount("");

        enqueueSnackbar("Exit Successful", { variant: "success", autoHideDuration: 5000, });

        refreshPoolLP(chainID);

        onClose();
      })
      .catch((e) => {
        setLoading(false);
        enqueueSnackbar("Exit Failed (" + e.reason + ")", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
  };

  const withdraw = () => {
    console.log("Attempting to token withdraw...");
    setLoading(true);

    withdrawStack(tokenAddress, +amount, poolIndex, stacking, signer)
      .then(() => {
        setLoading(false);
        setAmount("");

        enqueueSnackbar("Withdraw Successful", { variant: "success", autoHideDuration: 5000, });

        refreshPoolLP(chainID);

        onClose();
      })
      .catch((e) => {
        setLoading(false);
        enqueueSnackbar("Withdraw Failed (" + e.reason + ")", {
          variant: "error",
          autoHideDuration: 5000,
        });
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      classes={{ paper: classes.dialogContainer }}
    >
      <DialogTitle onClose={onClose}>UnStake LP Tokens</DialogTitle>

      <hr className={classes.hr} />

      <div className={classes.titleSection}>
        <div className={classes.container}>
          <InputBase
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.0"
            classes={{ root: classes.input, input: classes.inputBase }}
          />
          <div className="d-flex align-items-center justify-content-end mt-1">
            <span>Staked: {stakedBefore}</span>

            <Fab
              variant="extended"
              color="primary"
              className={classes.fab_max}
              onClick={() => setAmount(stakedBefore)}
            >
              Max
            </Fab>
          </div>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              size="large"
              variant="outlined"
              color="primary"
              onClick={onClose}
              className={classes.buttons}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item xs={6}>
            <div className={classes.infoLoadingBTNBox}>
              <LoadingButton
                loading={loading}
                valid={isBtnEnabled()}
                success={false}
                fail={false}
                onClick={() => (amount == stakedBefore ? exit() : withdraw())}
              >
                {amount == stakedBefore ? "Close All" : "UnStake"}
              </LoadingButton>{" "}
            </div>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
}

UnStackDialog.propTypes = {};

export default UnStackDialog;
